var Backbone, SupportCategorizationView, SupportHelpWizardController,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportHelpWizardController = require('../helpWizardController');

Backbone = require('backbone');

Backbone.$ = $;

SupportCategorizationView = (function(superClass) {
  extend(SupportCategorizationView, superClass);

  function SupportCategorizationView() {
    this.redirectingToOrder = bind(this.redirectingToOrder, this);
    return SupportCategorizationView.__super__.constructor.apply(this, arguments);
  }

  SupportCategorizationView.prototype.events = {
    'click #web-v2-my-order': 'onMyOrderSelection',
    'click #web-v2-my-account': 'onMyAccountSelection',
    'click #web-v2-something-else': 'onSomethingElseSelection',
    'click #web-v2-pre-purchase': 'onPrePuchaseSelection'
  };

  SupportCategorizationView.prototype.render = function() {
    switch (window.landingStep) {
      case 'step_1':
        $('#web-v2-my-order').addClass('active');
        break;
      case 'step_2':
        $('#web-v2-my-account').addClass('active');
    }
    return window.hideFloatingBoldChat();
  };

  SupportCategorizationView.prototype.getCurrentActiveButton = function() {
    var currentActiveButton;
    return currentActiveButton = $('.active', this.$el);
  };

  SupportCategorizationView.prototype.redirectingToOrder = function() {
    return SupportHelpWizardController.initOrdersFetch();
  };

  SupportCategorizationView.prototype.onMyOrderSelection = function() {
    var currentActiveButton, targetButtonId;
    targetButtonId = 'web-v2-my-order';
    currentActiveButton = this.getCurrentActiveButton();
    if ((currentActiveButton != null ? currentActiveButton.attr('id') : void 0) !== targetButtonId) {
      this.resetGlobalValues();
      Groupon.Support.ABOUT_AN_ORDER = true;
      this.activateTargetButton(currentActiveButton, targetButtonId);
      if (currentUser) {
        return this.redirectingToOrder();
      } else {
        return this.redirectToUserSignIn({
          myOrder: true,
          id: "my-order-sign-in"
        });
      }
    }
  };

  SupportCategorizationView.prototype.onMyAccountSelection = function() {
    var currentActiveButton, targetButtonId;
    targetButtonId = 'web-v2-my-account';
    currentActiveButton = this.getCurrentActiveButton();
    if ((currentActiveButton != null ? currentActiveButton.attr('id') : void 0) !== targetButtonId) {
      this.resetGlobalValues();
      Groupon.Support.ACCOUNT_RELATED = true;
      this.activateTargetButton(currentActiveButton, targetButtonId);
      if (currentUser) {
        return this.redirectSelectIssue();
      } else {
        return this.redirectToUserSignIn({
          myAccount: true,
          id: "my-account-sign-in"
        });
      }
    }
  };

  SupportCategorizationView.prototype.onSomethingElseSelection = function() {
    var currentActiveButton, targetButtonId;
    targetButtonId = 'web-v2-something-else';
    currentActiveButton = this.getCurrentActiveButton();
    if ((currentActiveButton != null ? currentActiveButton.attr('id') : void 0) !== targetButtonId) {
      this.resetGlobalValues();
      Groupon.Support.SOMETHING_ELSE = true;
      this.activateTargetButton(currentActiveButton, targetButtonId);
      return this.redirectSelectIssue();
    }
  };

  SupportCategorizationView.prototype.onPrePuchaseSelection = function() {
    var currentActiveButton, targetButtonId;
    targetButtonId = 'web-v2-pre-purchase';
    currentActiveButton = this.getCurrentActiveButton();
    if (this.targetButtonIsActive(currentActiveButton, targetButtonId) !== true) {
      this.resetGlobalValues();
      Groupon.Support.PRE_PURCHASE = true;
      this.activateTargetButton(currentActiveButton, targetButtonId);
      return this.redirectSelectIssue();
    }
  };

  SupportCategorizationView.prototype.targetButtonIsActive = function(currentActiveButton, targetButtonId) {
    return (currentActiveButton != null ? currentActiveButton.attr('id') : void 0) === targetButtonId;
  };

  SupportCategorizationView.prototype.resetGlobalValues = function() {
    Groupon.Support.SOMETHING_ELSE = false;
    Groupon.Support.ACCOUNT_RELATED = false;
    Groupon.Support.ABOUT_AN_ORDER = false;
    return Groupon.Support.PRE_PURCHASE = false;
  };

  SupportCategorizationView.prototype.activateTargetButton = function(currentActiveButton, targetButtonId) {
    currentActiveButton.removeClass('active');
    return $("#" + targetButtonId, this.$el).addClass('active');
  };

  SupportCategorizationView.prototype.deActivateCurrentActiveButton = function() {
    var ref;
    return (ref = this.getCurrentActiveButton()) != null ? ref.removeClass('active') : void 0;
  };

  SupportCategorizationView.prototype.redirectToUserSignIn = function(options) {
    return SupportHelpWizardController.renderUserSignIn(options);
  };

  SupportCategorizationView.prototype.redirectSelectIssue = function(targetButtonId) {
    Groupon.Support.ContentModel.init(null);
    return SupportHelpWizardController.abruptStepTwoFlow();
  };

  return SupportCategorizationView;

})(Backbone.View);

module.exports = SupportCategorizationView;

//# sourceMappingURL=data:application/json;base64,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
